module.exports = "\n<router-outlet (activate)=\"onActivate($event)\" ></router-outlet>\n"